// src/utils/url/setQueryParam.ts
export function setQueryParam(
  key: string,
  value: string,
  opts?: { replace?: boolean },
) {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);

  // ✅ keep same route, only change query
  const next = url.pathname + "?" + url.searchParams.toString() + url.hash;

  if (opts?.replace) {
    window.history.replaceState({}, "", next);
  } else {
    window.history.pushState({}, "", next);
  }

  // ✅ IMPORTANT: notify react-router that URL changed (popstate does not fire on pushState)
  window.dispatchEvent(new PopStateEvent("popstate"));
}
